import produce from 'immer'
import { types } from './actions'

export const FRAME_STATES = {
    CREATED: 'CREATED',
    HIDDEN: 'HIDDEN',
    DISPLAYED: 'DISPLAYED',
    DESTROYED: 'DESTROYED',
}

export const initialState = {
    maxRetries: 0,
    appErrors: 0,
    frames: {},
    allFramesReady: false,
    init: false,
}

const reducer = (state = initialState, { type, payload, frame }) => produce(state, (draftState) => {
    switch (type) {
        case types.FRAME_CREATE:
            draftState.frames[frame] = {
                status: FRAME_STATES.CREATED,
                init: false,
                payload,
            }
            break
        case types.FRAME_SHOW:
            draftState.frames[frame].status = FRAME_STATES.DISPLAYED
            break
        case types.FRAME_HIDE:
            draftState.frames[frame].status = FRAME_STATES.HIDDEN
            break
        case types.FRAME_DESTROY:
            draftState.frames[frame].status = FRAME_STATES.DESTROYED
            break
        case types.FRAME_TOGGLE:
            if (state.frames[frame].status === FRAME_STATES.HIDDEN) {
                draftState.frames[frame].status = FRAME_STATES.DISPLAYED
            } else if (state.frames[frame].status === FRAME_STATES.CREATED) {
                draftState.frames[frame].status = FRAME_STATES.DISPLAYED
            }
            break
        case types.FRAME_INIT:
            draftState.frames[frame].init = true
            draftState.allFramesReady = Object.values(draftState.frames).every((f) => f.init)
            break
        case types.PICO_INIT:
            draftState.init = true
            break
        case types.SEND_APP_ERROR:
            draftState.appErrors += 1
            break
        default:
            break
    }

    return draftState
})

export default reducer
